export default "__VITE_ASSET__Dn3Yb8Jj__"